<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'hand-holding']" />
        <span class="title">Manual classification</span>
      </Header>
      <v-row
        class="tabel"
        v-for="item in project.parents"
        :key="item.parent_id"
      >
        <v-col class="col-1"><font-awesome-icon :icon="item.icon"/></v-col>
        <v-col class="col-2">{{ item.label }}</v-col>
        <span v-for="item2 in project.childs[item.parent_id]" :key="item2.id">
          <v-col>
            <input
              type="checkbox"
              v-model="item2.active"
              false-value="false"
              true-value="true"
              @change="change(item2)"
            />
            {{ item2.label }}
          </v-col>
        </span>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      project: {}
    };
  },
  //type: "getclass_childs".
  components: {
    Header
  },
  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "settings_class_manual"
    })
      .then(response => {
        console.log(response.data);
        this.project = response.data;
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  },
  methods: {
    change(test) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_subclass_update",
        vars: test
      });
    }
  }
};
</script>
<style scoped>
.tabel .col {
  width: 160px;
}
.row {
  border-bottom-style: solid;
  border-bottom-width: thin;
}
.v-input {
  width: 50px;
}
.tabel .col,
.tabel .col-8,
.tabel .col-4 {
  padding: 11px;
  height: 55px;
}
.tabel svg {
  height: 30px;
}
</style>
